import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { Link } from "react-router-dom";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Importation corrigée
import { ca } from "date-fns/locale";

const InformationAdmin = () => {
  const [titre, setTitre] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [document, setDocument] = useState(null);
  const [contenu, setContenu] = useState(null);
  const [contenu2, setContenu2] = useState(null);
  const [sviewingProjet, setSviewingProjet] = useState("");





  const [video, setVideo] = useState("");
  const [origineMission, setOrigineMission] = useState("");
  const [caractereInnovant, setCaractereInnovant] = useState("");
  const [descriptionTechnique, setDescriptionTechnique] = useState("");
  const [besoinExpose, setBesoinExpose] = useState("");
  const [moyensPourReussir, setMoyensPourReussir] = useState("");
  const [critereReussite, setCritereReussite] = useState("");
  const [besoinsEventuels, setBesoinsEventuels] = useState("");

  const [calendrierFin, setCalendrierFin] = useState("");
  const [calendrierDebut, setCalendrierDebut] = useState("");

  const [step, setStep] = useState(1);

  const [categorieId, setCategorieId] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [projetId, setProjetId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteProjet, setDeleteProjet] = useState(null);

  const [projetToDelete, setProjetToDelete] = useState(null);
  const showDeleteModal = (id) => {
    setProjetToDelete(id);
    setIsDeleteModalVisible(true);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setProjetToDelete(null);
  };
  const confirmDelete = async () => {
    if (projetToDelete) {
      await handleDelete(projetToDelete);
      setIsDeleteModalVisible(false);
    }


  };

  const handleDeleteConfirm = (projet) => {
    setDeleteProjet(projet);
    setDeleteModalVisible(true);
  };
  const [projets, setProjets] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState(null);

  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupérer le premier fichier sélectionné
    if (file) {
      setImage(file); // Mettre à jour l'état avec l'image sélectionnée
    }
  };

  // const truncateText = (text, wordLimit) => {
  //   const words = text.split(" ");
  //   if (words.length > wordLimit) {
  //     return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
  //   }
  //   return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  // };
  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ""; // Retourne une chaîne vide si text est undefined ou null
    }
  };

  const fetchProjets = async () => {
    try {
      const response = await baseApiUrl.get("/information/liste");

      // Vérification du statut HTTP de la réponse
      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Les données sont accessibles directement via `response.data` avec axios
      const data = response.data;

      if (!data || data.length === 0) {
        console.warn("Aucun projet trouvé.");
      }

      // Met à jour l'état avec les projets récupérés
      setProjets(data);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des projets:",
        error.message || error
      );
      openNotificationWithIcon(
        "error",
        "Erreur lors de la récupération des projets."
      );
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get(
        "/categorie/liste"
      );

      // Transformer les données pour correspondre au format des options de <Select>
      const options = response.data.map((category) => ({
        value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
        label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
      }));

      setCategoriesOptions(options);
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProjets();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token"); // Assurez-vous que c'est le bon nom de clé
    if (token) {
      try {
        const decoded = jwtDecode(token); // Utilisation de jwtDecode
        setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
        console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
    }

  }, []);

  const handleAddProjet = async (e) => {
    e.preventDefault();

    if (!titre || !contenu) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();
      const projetData = {
        titre,
        contenu,
        contenu2,
      };

      console.log("Données du projet :", projetData);

      formData.append("information", new Blob([JSON.stringify(projetData)], {
        type: "application/json"
      }));

      if (image) {
        formData.append("image", image);
      }

      const response = await baseApiUrl.post("/information/creer", formData);

      const newProjet = response.data;

      console.log("Réponse API :", newProjet);

      setProjets([newProjet, ...projets]);

      // Notification de succès
      openNotificationWithIcon("success", "Information ajouté avec succès.");
      fetchProjets();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du projet.");
      console.error("Erreur détectée :", error.response?.data || error.message || error);
    }

    // Réinitialiser le formulaire
    resetForm();
  };



  const handleEditProjet = async (e) => {
    e.preventDefault();

    // Vérification si un projet est sélectionné pour la modification
    if (!editingProjet) {
      openNotificationWithIcon("error", "Aucun projet sélectionné pour la modification.");
      return;
    }

    // Vérification que tous les champs nécessaires sont remplis
    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    // Préparation des données du projet
    const projetData = {
      titre,
      contenu,
      contenu2,
      image,
    };

    // Création de FormData pour les requêtes multipart/form-data
    const formData = new FormData();
    formData.append("information", new Blob([JSON.stringify(projetData)], { type: "application/json" }));
    if (image) formData.append("image", image); // Ajout de l'image si elle existe

    try {
      // Envoi de la requête pour modifier le projet
      const response = await baseApiUrl.put(`/information/modifier/${editingProjet.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Mise à jour de la liste des projets
      const updatedProjet = await response.data;
      console.log("Projet mis à jour:", updatedProjet);

      setProjets(
        projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
      );

      openNotificationWithIcon("success", "Information modifié avec succès.");
    } catch (error) {
      console.error("Erreur lors de la modification du projet:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
    }

    // Réinitialisation du formulaire après l'envoi
    resetForm();
  };





  const handleEdit = (projet) => {
    setViewingProjet(projet);
    setEditingProjet(projet);
    setTitre(projet.titre);
    setContenu(projet.contenu);
    setContenu2(projet.contenu2);
    setImage(projet.image);
    setDocument(projet.document);

    setIsEditMode(true);
    setIsEditModalVisible(true);


    setSelectedCategorie(projet.categorieId); // Assurez-vous de définir la catégorie sélectionnée correctement
    setIsEditModalVisible(true);
  };

  const handleDeletes = async (idProjet) => {
    try {
      const response = await baseApiUrl.delete(
        `/information/supprimer/${idProjet}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      setProjets(projets.filter((projet) => projet.id !== idProjet));
      setDeleteModalVisible(false);
      setDeleteProjet(null);
      openNotificationWithIcon("success", "Projet supprimé avec succès.");
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la suppression du projet."
      );
      console.error("Erreur:", error);
    }
  };

  const handleDelete = async (idProjet) => {
    try {

      const response = await baseApiUrl.delete(`/information/supprimer/${idProjet}`);

      if (response.status !== 200 && response.status !== 204) {
        console.error(`Statut inattendu : ${response.status}`); // Log du statut inattendu
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Mise à jour de la liste des publications
      setProjets((prevPublications) =>
        prevPublications.filter((projet) => projet.id !== idProjet)
      );


      setDeleteModalVisible(false);
      setDeleteProjet(null);

      // Afficher une notification de succès
      openNotificationWithIcon("success", "Information supprimée avec succès.");
    } catch (error) {
      // Logs pour les erreurs
      console.error("Erreur lors de la suppression :", error.message || error);
      openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de la suppression de la publication."
      );
    }
  };

  const handleStatusChange = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du info:", key); // Assurez-vous que key n'est pas undefined

    if (!key) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/information/activeDesactive/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchProjets(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du projet:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);
      // Vous pouvez afficher la réponse de l'API si nécessaire
      //   console.log(response.data); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
      // } catch (error) {
      //   console.error('Erreur lors de la mise à jour du projet:', error);
      // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
    }
  };

  const resetForm = () => {
    setStep(1);
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    setTitre("");
    setOrigineMission("");
    setCaractereInnovant("");
    setContenu("");
    setContenu2("");


    setImage("");


    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };



  // const filteredProjets = projets.filter(
  //   (projet) =>
  //     projet.titre &&
  //     projet.titre.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const filteredProjets = projets.filter((projet) => {
    const titre = projet.titre && projet.titre.toLowerCase().includes(searchTerm.toLowerCase());
    // const descriptionTechnique = projet.descriptionTechnique && projet.descriptionTechnique.toLowerCase().includes(searchTerm.toLowerCase());
    // const origineMission = projet.origineMission && projet.origineMission.toLowerCase().includes(searchTerm.toLowerCase());

    return titre;
  });


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Informations</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                type="success"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "Titre",
                dataIndex: "titre",
                key: "titre",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              {
                title: "Description 1",
                dataIndex: "contenu",
                key: "contenu2",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              // {
              //   title: "Description 2",
              //   dataIndex: "contenu2",
              //   key: "contenu2",
              //   render: (text) => truncateText(text, 6), // Tronque la description à 10 mots
              // },

              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange(record.id, checked)
                    }
                  />
                ),
              },

              {
                title: "Image",
                dataIndex: "image",
                key: "image",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="project"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },
              {
                // title: "Actions",
                // key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button

                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => {
                        resetForm();
                        handleView(record);
                      }}
                    >
                      Voir
                    </Button>
                    <Button

                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => {
                        resetForm();
                        handleEdit(record);

                      }}
                    >
                      Modifier
                    </Button>

                    <Button

                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredProjets}
          />

          {/* Modal d'ajout de projet */}
          <Modal
            title="Ajouter une information"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleAddProjet}>


              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Titre de l'information</label>
                    <input
                      type="text"
                      className="form-control"
                      value={titre}
                      onChange={(e) => setTitre(e.target.value)}
                    />
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Description1 de l'info</label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={contenu}
                      onChange={(e) => setContenu(e.target.value)}
                      style={{ width: "100%", height: "100px" }}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Description2 de l'info</label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={contenu2}
                      onChange={(e) => setContenu2(e.target.value)}
                      style={{ width: "100%", height: "100px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">

                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Image de Info</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>




              <button
                type="submit"
                className="btn btn-primary"

              >
                Créer
              </button>


            </form>
          </Modal>

          <Modal
            title="Modifier une information"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleEditProjet}>


              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Titre de l'information</label>
                    <input
                      type="text"
                      className="form-control"
                      value={titre}
                      onChange={(e) => setTitre(e.target.value)}
                    />
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Description1 de l'info</label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={contenu}
                      onChange={(e) => setContenu(e.target.value)}
                      style={{ width: "100%", height: "100px" }}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Description2 de l'info</label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={contenu2}
                      onChange={(e) => setContenu2(e.target.value)}
                      style={{ width: "100%", height: "100px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">

                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Image de Info</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>




              <button
                type="submit"
                className="btn btn-primary"

              >
                Créer
              </button>


            </form>
          </Modal>


          {/* <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onOk={confirmDelete}
            onCancel={handleCancelDelete}
            okText="Supprimer"
            cancelText="Annuler"
          >
            <p>
              Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est
              irréversible.
            </p>
          </Modal> */}

          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => handleDelete(deleteProjet.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>
              Êtes-vous sûr de vouloir supprimer cette information ? Cette action est
              irréversible.
            </p>
          </Modal>

          {/* Modal de modification de projet */}


          {/* Modal pour afficher les détails  */}
          <Modal
            title="Détails du l'information"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
          // footer={[
          //   <Button key="close" onClick={() => setIsViewModalVisible(false)}>
          //     Fermer
          //   </Button>,
          // ]}
          >
            {viewingProjet && (
              <div>
                <p>
                  <strong>Titre de l'information:</strong> {viewingProjet?.titre}
                </p>
                <p>
                  <strong>Description 1 de l'information:</strong> {viewingProjet?.contenu}
                </p>
                <p>
                  <strong>Description 2 de l'information:</strong> {viewingProjet?.contenu2}
                </p>
                {/* <p>
                  <strong>URL de l'image:</strong> {sviewingProjet?.imageUrl}
                </p> */}
              </div>
            )}
          </Modal>


        </div>
      </div>
    </>
  );
};

export default InformationAdmin;
